import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const shippingAPI = {
  // Get all shipping methods (admin)
  getAll: async () => {
    const token = localStorage.getItem('adminToken');
    const response = await axios.get(`${API_URL}/shipping`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  // Get active shipping methods (public)
  getActive: async (country, weight, orderTotal) => {
    const params = new URLSearchParams();
    if (country) params.append('country', country);
    if (weight) params.append('weight', weight);
    if (orderTotal) params.append('orderTotal', orderTotal);
    
    const response = await axios.get(`${API_URL}/shipping/active?${params.toString()}`);
    return response.data;
  },

  // Get single shipping method
  getById: async (id) => {
    const token = localStorage.getItem('adminToken');
    const response = await axios.get(`${API_URL}/shipping/${id}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  // Create shipping method
  create: async (data) => {
    const token = localStorage.getItem('adminToken');
    const response = await axios.post(`${API_URL}/shipping`, data, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  // Update shipping method
  update: async (id, data) => {
    const token = localStorage.getItem('adminToken');
    const response = await axios.put(`${API_URL}/shipping/${id}`, data, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  // Delete shipping method
  delete: async (id) => {
    const token = localStorage.getItem('adminToken');
    const response = await axios.delete(`${API_URL}/shipping/${id}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  // Toggle active status
  toggleActive: async (id) => {
    const token = localStorage.getItem('adminToken');
    const response = await axios.patch(`${API_URL}/shipping/${id}/toggle`, {}, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  // Calculate shipping cost
  calculateCost: async (methodId, weight, country, orderTotal) => {
    const response = await axios.post(`${API_URL}/shipping/calculate`, {
      methodId,
      weight,
      country,
      orderTotal
    });
    return response.data;
  },

  // Generate shipping label PDF
  generateLabel: async (shipmentData) => {
    const token = localStorage.getItem('adminToken');
    const response = await axios.post(`${API_URL}/shipping/generate-label`, shipmentData, {
      headers: { 
        Authorization: `Bearer ${token}`,
      },
      responseType: 'blob' // Important for PDF download
    });
    return response.data;
  },

  // Send shipping label via email
  sendLabel: async (shipmentData) => {
    const token = localStorage.getItem('adminToken');
    const response = await axios.post(`${API_URL}/shipping/send-label`, shipmentData, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  }
};

export default shippingAPI;
